import React from "react";
import Icon from "../../assets/assets/cbn-icon.png";
import { Link } from "react-router-dom";
import moment from "moment";
import { PropTypes } from "prop-types";
import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";

const Expiry = ({ days_left, expired, date }) => {
  const expiry_date = moment.utc(date).format("Do MMMM, YYYY");

  return (
    <div>
      {expired ? (
        <div className="exp-wrapper">
          <div className="cbn">
            <img src={Icon} alt="cbn-icon" />
          </div>
          <div className="cbn-text">
            <span id="head">CBN LICENSE</span>
            <span id="text">
              Expires <br /> {expiry_date}
            </span>
          </div>
          <div className="progress-bar">
            <CircularProgressbarWithChildren
              value={days_left}
              strokeWidth={4}
              styles={buildStyles({
                rotation: 0.25,
                strokeLinecap: "butt",
                textSize: "14px",
                pathTransitionDuration: 0.5,
                pathColor: "red",
                textColor: "#808080",
                trailColor: "#d6d6d6",
                backgroundColor: "#3e98c7",
              })}
            >
                <div className="text-div">
                  <div className="text-bar1">Expired</div>
                </div>
            </CircularProgressbarWithChildren>
          </div>
          <hr />
          <div className="exp-text">
            <p>
              Your account has been suspended. Please update your license to
              reactivate your account
            </p>
          </div>
          {expired && (
            <Link className="update" to="/update">
              <span>update</span>
            </Link>
          )}
        </div>
      ) : (
        <div className="exp-wrapper">
          <div className="cbn">
            <img src={Icon} alt="cbn-icon" />
          </div>
          <div className="cbn-text">
            <span id="head">CBN LICENSE</span>
            <span id="text">
              Expires <br /> {expiry_date}
            </span>
          </div>
          <div className="progress-bar">
            <CircularProgressbarWithChildren
              value={days_left}
              strokeWidth={4}
              styles={buildStyles({
                rotation: 0.25,
                strokeLinecap: "butt",
                textSize: "14px",
                pathTransitionDuration: 0.5,
                pathColor: `${days_left <= 10 ? "red" : "lightgreen"}`,
                textColor: "#808080",
                trailColor: "#d6d6d6",
                backgroundColor: "#3e98c7",
              })}
            >
                <div className="text-div">
                  <div className="text-bar1">{days_left}</div>
                  <div className="text-bar2">Days Left</div>
                </div>
            </CircularProgressbarWithChildren>
          </div>
          <hr />
          <div className="exp-text">
            <p>Renew your license before your account gets suspended</p>
          </div>
        </div>
      )}
    </div>
  );
};

Expiry.propTypes = {
  days_left: PropTypes.number,
  expired: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
};

export default Expiry;
